import React from "react";
import ChatMessage from "./ChatMessage";
import '../../../assets/sass/components/messages/chat/chat-send.scss';

class ChatSend extends ChatMessage {

    messageHtml = () => {
        var {data} = this.props;

        return (
            <div className="chat-send">
                <img className="chat-avatar" src={data.avatar} alt={data.name}/>
                <div className="send-content">
                    {this.appendContent(data)}
                    <time className="date">{ data.date ?? "Today 12:30 pm"}</time>
                </div>
            </div>
        )
    }
};

export default ChatSend;